<template>
	<div class="announcement-overview">
		<MStateBox :loading="isLoading" :empty="isEmpty">
			<MobDocumentCard
				v-if="currentData.length"
				:listData="currentData"
				:showIcon="true"
				@goDetail="handlePreview"
			/>
		</MStateBox>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import MobDocumentCard from '@rebuild/materials/shared/common/MobDocumentCard.vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCurrentContext } from '@rebuild/materials/shared/announcement/context';

const route = useRoute();
const { announcement } = useModuleData();
const { viewModule } = useModuleNavigation();

const context = useCurrentContext();
const languageType = computed(() => context.languageType);

const currentData = computed(() => {
	const all = (announcement.data?.data || announcement.data?.rows || []).slice(0, 8).map(item => ({
		...item,
		time: item.publishDate,
		classificationInfo: item.parentClassification
	}));
	const slice = route.query.slice;
	if (slice === 'left4') return all.slice(0, 4);
	if (slice === 'right4') return all.slice(4, 8);
	return all;
});

const isLoading = computed(() => announcement.loading);
const isEmpty = computed(() => announcement.empty || !currentData.value.length);

const handlePreview = info => {
	viewModule('announcement', info);
};

const refresh = async () => {
	let obj = {
		useStockCode: true,
		pageNum: 20,
		pageStart: 0,
		order: 'desc',
		isPublish: true
	};
	if (languageType.value) {
		obj = { ...obj, ...languageType.value };
	}
	await announcement.refresh(obj);
};

onMounted(() => {
	refresh();
});
</script>

<style lang="less" scoped></style>
